import ComparisonTable from "../../components/ComparisonTable";
import GridItem from "../../components/general/GridItem";
import { getUrlFromStoryblokLink } from "../../utils/storyblok/urls";
import { notUndefined } from "../../utils/type-guards/general";

const ComparisonTableModule = ({
	headline,
	richtext,
	items,
	compareMore,
	label,
}: Queries.ComparisonTableModuleFragment) => {
	const compare = compareMore?.[0];
	const linkProps =
		compare && compare.link && typeof compare.label === "string"
			? {
					link: getUrlFromStoryblokLink(compare.link),
					label: compare.label,
				}
			: { link: "", label: "" };

	const itemsProps = items
		?.map((item) => {
			if (!item || !item.image) return;

			const readMore = item.readMore?.[0];
			const linkProps =
				readMore && readMore.link && typeof readMore.label === "string"
					? {
							link: getUrlFromStoryblokLink(readMore.link),
							label: readMore.label,
						}
					: undefined;

			const contentProps = item.compare
				?.map((compareItem) => {
					if (!compareItem?.label) return;

					if (compareItem.description) {
						return {
							uid: compareItem._uid ?? "",
							label: compareItem.label,
							value: compareItem.description,
						};
					} else if (compareItem.value) {
						return {
							uid: compareItem._uid ?? "",
							label: compareItem.label,
							value: JSON.parse(compareItem.value) as string, // TODO Add type check
						};
					} else {
						return {
							uid: compareItem._uid ?? "",
							label: "",
							value: "",
						};
					}
				})
				.filter(notUndefined);

			return {
				uid: item._uid ?? "",
				image: { alt: item.image.alt, src: item.image.filename },
				productName: item.name ?? "",
				content: contentProps ?? [{ uid: "", label: "", value: "" }],
				readMore: linkProps ?? { link: "", label: "" },
			};
		})
		.filter(notUndefined);

	return itemsProps ? (
		<GridItem fullWidth>
			<ComparisonTable
				headline={headline ?? ""}
				richtext={richtext ?? ""}
				items={itemsProps}
				compareMore={linkProps}
				label={label ?? ""}
			/>
		</GridItem>
	) : null;
};

export default ComparisonTableModule;
